<script lang="ts" context="module">
  export type ExpandableEdge = "top-start" | "top-end" | "bottom-start" | "bottom-end" | "none";
</script>

<script lang="ts">
  export let sticky = false;
  export let isExpanded = false;
  export let expandableEdge: ExpandableEdge = "none";
  export let columnID: string;
</script>

<div
  role="gridcell"
  class:sticky
  class:type-cell-sticky={sticky && columnID === "type"}
  class:expanded-group-top-start={isExpanded && expandableEdge === "top-start"}
  class:expanded-group-top-end={isExpanded && expandableEdge === "top-end"}
  class:expanded-group-bottom-start={isExpanded && expandableEdge === "bottom-start"}
  class:expanded-group-bottom-end={isExpanded && expandableEdge === "bottom-end"}
  style:background={isExpanded ? "var(--rk-neutral-0)" : "#fff"}
>
  <slot />
</div>

<style>
  div[role="gridcell"] {
    display: flex;
    align-items: center;
    height: 64px;
    padding-left: var(--pl);
    padding-right: var(--pr);
    min-width: var(--minW);
  }

  .sticky {
    position: sticky;
    z-index: 1;
    background-color: white;
    left: var(--pos-left);
  }

  .type-cell-sticky::after {
    content: "";
    position: absolute;
    top: 0;
    left: 100%;
    bottom: 0;
    display: block;
    width: var(--scroll-gradient-width);
    will-change: width;
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.01) 38.87%,
      rgba(0, 0, 0, 0.02) 60.71%,
      rgba(0, 0, 0, 0.03) 75.41%,
      rgba(0, 0, 0, 0.03) 90.08%,
      rgba(0, 0, 0, 0.04) 97.27%,
      rgba(0, 0, 0, 0.06) 99.46%,
      rgba(0, 0, 0, 0.11) 100%
    );
    transition: width 0.2s ease-in-out;
  }

  .expanded-group-top-start {
    border-top-left-radius: var(--rk-rounding-s);
  }

  .expanded-group-top-end {
    border-top-right-radius: var(--rk-rounding-s);
  }

  .expanded-group-bottom-start {
    border-bottom-left-radius: var(--rk-rounding-s);
  }

  .expanded-group-bottom-end {
    border-bottom-right-radius: var(--rk-rounding-s);
  }
</style>
